import {
  pasos as pasosComunes,
  premios as premiosCajaAhorro,
  beneficios as beneficiosCajaAhorro
} from "@/config/brands/ofertaCommon";

const legales_ca = `CARTERA DE CONSUMO. Mantenimiento Mensual: $0. (*) Para más información consulta en <a href="https://www.bbva.com.ar/personas/productos/cuentas/ahorro.html" target="_blank">>https://www.bbva.com.ar/personas/productos/cuentas/ahorro.html</a> <br />
    "Los depósitos en pesos y en moneda extranjera cuentan con la garantía de hasta $ 1.500.000. En las operaciones a nombre
    de dos o más personas, la garantía se prorrateará entre sus titulares. En ningún caso, el total de la garantía por persona y por
    depósito podrá exceder de $ 1.500.000, cualquiera sea el número de cuentas y/o depósitos. Ley 24485, Decreto 540/1995 y
    modificatorios y Com. "A" 2337 y sus modificatorias y complementarias. Se encuentran excluidos los captados a tasas
    superiores a la de referencia conforme a los límites establecidos por el Banco Central, los adquiridos por endoso y los
    efectuados por personas vinculadas a la entidad financiera."<br />
    Los accionistas de BANCO BBVA ARGENTINA S.A. limitan su responsabilidad a la integración de las
    acciones suscriptas a la ley 19.550 y ley 25.738. CUIT 30-50000319-3. Av. Córdoba 111, piso 31, CABA -
    CP 1054.
`;

const legales_motorTCCA = {
  cajaAhorro: `<strong>Cartera de Consumo Caja de Ahorro</strong><br />
      Mantenimiento Mensual: $0. (*) Para más información consulta en
      <a href="https://www.bbva.com.ar/personas/productos/cuentas/ahorro.html" target="_blank">https://www.bbva.com.ar/personas/productos/cuentas/ahorro.html</a> "Los
      depósitos en pesos y en moneda extranjera cuentan con la garantía de hasta
      $ 1.500.000. En las operaciones a nombre de dos o más personas, la
      garantía se prorrateará entre sus titulares. En ningún caso, el total de
      la garantía por persona y por depósito podrá exceder de $ 1.500.000,
      cualquiera sea el número de cuentas y/o depósitos. Ley 24485, Decreto
      540/1995 y modificatorios y Com. "A" 2337 y sus modificatorias y
      complementarias. Se encuentran excluidos los captados a tasas superiores a
      la de referencia conforme a los límites establecidos por el Banco Central,
      los adquiridos por endoso y los efectuados por personas vinculadas a la
      entidad financiera." <br /><br />
      Los accionistas de BANCO BBVA ARGENTINA S.A. limitan su responsabilidad a
      la integración de las acciones suscriptas a la ley 19.550 y ley 25.738.
      CUIT 30-50000319-3. Av. Córdoba 111, piso 31, CABA - CP 1054.`,
  paquetes: `<strong>Cartera de Consumo Tarjeta de Crédito</strong><br />
      Oferta válida para altas efectuadas hasta el 30/09/2026. Sujeta a
      aprobación crediticia.$sin_consumo Podés mantener la bonificación del 100% del costo
      de mantenimiento de tu cuenta por 6 meses más siempre que alcances o
      superes la suma de $consumo en consumos con tus
      tarjetas de crédito y cada resumen. Cada mes se debitará el costo de
      mantenimiento de tu cuenta, y el mes que alcances los consumos necesarios
      para acceder a la bonificación, te devolveremos la comisión debitada.El
      Banco podrá modificar los montos necesarios para acceder a la
      bonificación, y te lo informará previamente.$sin_consumo<br /><br />

      La comisión de mantenimiento anual del Programa Millas BBVA estará
      bonificada hasta el 31/12/2026. Pasada esa fecha, comenzarás a abonar la
      comisión vigente publicada en la Tabla de Comisiones a esa fecha. Comisión
      de mantenimiento anual del Programa de Millas BBVA al día de hoy es:
      $2.420.<br /><br />

      <strong>¿Cómo acumulo Millas BBVA?</strong><br />
      Sumarán millas los consumos en pesos y en dólares realizados con la/s
      tarjeta/s de crédito adherida/s al Programa de Millas BBVA. Los consumos
      de los adicionales acumularán millas automáticamente en la Cuenta del
      titular de las mismas. Por cada 1 dólar consumido o equivalente en $ARG,
      se acumulará 1 milla, es decir 1 u$s = 1 milla. El tipo de cambio a
      utilizar será el tipo de cambio vendedor informado por el banco el día de
      cierre de cada liquidación de tarjeta.<br /><br />

      <strong>¿Qué consumos no suman Millas BBVA?</strong><br />
      Consumos realizados con una financiación de 3, 6 o 9 meses bajo el
      Programa de Fomento al Consumo y a la Producción de Bienes y Servicios,
      denominado “AHORA 12”<br />
      Consumos con una financiación de 12 meses o más, con bonificaciones por
      promociones y los desconocimientos de compra.<br />
      Montos del PLAN V, sus respectivos impuestos y comisiones.<br />
      Montos generados por otros conceptos.<br /><br />

      Millas BBVA es un programa exclusivo para clientes del BBVA. Podes
      consultar los Términos y Condiciones, ingresando a tu espacio personal de
      la Banca Online en <a href="https://www.bbva.com.ar" target="_blank">www.bbva.com.ar</a>.<br /><br />

      Usted puede revocar la aceptación de los productos o servicios solicitados
      dentro del plazo de diez días hábiles contados desde la fecha de recibido
      el contrato o de la disponibilidad efectiva del producto o servicio, o lo
      que suceda último, sin costo ni responsabilidad alguna de su parte,
      siempre que no los haya utilizado. Si hubiere sido utilizado, solo se le
      cobrarán los costos y comisiones previstos proporcionalmente al tiempo que
      los usó. La revocación deberá notificarse de manera fehaciente o por el
      mismo medio en que el servicio o producto fue contratado. El cliente podrá
      dar por finalizada la relación o revocar su aceptación en cualquier
      sucursal de la Entidad y/o por Home Banking cuando se trate de tarjetas,
      seguros, préstamos personales y/o cuentas. Los accionistas de Banco BBVA
      Argentina S.A. limitan su responsabilidad a la integración de las acciones
      suscriptas según Ley 19.550 y Ley 25.738. CUIT: 30‌-‌50‌00‌03‌19‌-‌3. Av.‌
      Córdoba 111‌, piso 31‌, CABA (CP‌: C105‌4AAA)`,
  tarjetaVos: `<strong>Cartera de Consumo Tarjeta Vos</strong><br />
      Oferta válida del 04/03/2022 al 30/09/2025.- Sujeto a aprobación
      crediticia. Costos de la comisión mensual de mantenimiento del paquete
      Express al 30/09/2025: $34.000. Costos de la comisión mensual de
      mantenimiento del paquete Gold al 30/09/2025: $55.000. Costos de la comisión mensual de mantenimiento del paquete
      Platinum al 30/09/2025: $81.000. Costos de la comisión mensual de
      mantenimiento del paquete Black al 30/09/2025: $91.000. Este
      beneficio estará vigente para las altas que se realicen hasta el
      30/09/2025 inclusive y siempre que la cuenta esté abierta dentro de los 60
      días posteriores a la compra. El cliente tendrá 60 días corridos para
      realizar una compra desde el alta de su tarjeta BBVA Vos. Los accionistas
      de Banco BBVA Argentina S.A. limitan su responsabilidad a la integración
      de las acciones suscriptas a la LEY 19.550 y LEY 25.738. CUIT
      30-50000319-3.`
};

/**
 * Configuración default de campaña de módulo
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  analyticsName: "caja de ahorro",
  analyticsTypology: "solicitud",
  analyticsType: "solicitud",
  googleAnalyticsId: "UA-179147834-1",
  googleGTMId: "GTM-TWRMS62",
  googleGTMGA4: true,
  modulo: "Cuenta y Tarjeta de Débito",
  cantPasos: 9,
  pasos: {
    ...pasosComunes,
    consulta: {
      component: "views/ConsultaCA",
      titulo: "Abrí tu Caja de ahorro en BBVA",
      subtitulo:
        "Te pedimos estos datos para poder abrir tu Caja de ahorro con tu Tarjeta de Débito.",
      analyticsName: "home"
    },
    ofertaCA: {
      titulo: "Caja de ahorro + Visa Débito",
      subtitulo: "Tené tu cuenta en BBVA y disfrutá de:",
      botonSiguiente: "Abrí tu cuenta en BBVA",
      footerText: legales_ca
    },
    ofertaCuenta: {
      path: "/ofertaCuenta",
      component: "views/OfertaTCCA",
      titulo: "Caja de ahorro + Visa Débito",
      subtitulo: "Tené tu cuenta en BBVA y disfrutá de:",
      botonSiguiente: "Abrí tu cuenta en BBVA",
      headerTheme: "light",
      footerText: legales_motorTCCA,
      footerLayout: "boxed"
    },
    gracias: {
      path: "/gracias",
      pasoAnterior: "sucursal",
      component: "views/Gracias",
      footerText: null
    },
    errorBBVAVos: {
      path: "/errorBBVAVos",
      component: "views/ErrorBBVAVos",
      titulo: "Tenés una solicitud de Tarjeta BBVA Vos en proceso",
      subtitulo: "En 24 vas a poder solicitar una nueva cuenta."
    }
  }
};

export const oferta = [
  "<strong>Caja de ahorro en pesos </strong><br>",
  "<strong>Tarjeta Visa Débito</strong>"
];

export const proximosPasos = [
  {
    label:
      "<strong>Ingresá a banca online.</strong> Cuando recibas tu tarjeta de débito, ingresá a banca online y creá tu Usuario y Clave digital.",
    modal: "Cómo obtener mi Usuario y Clave Digital"
  },
  {
    cbu: true,
    label:
      "Te damos tu número de CBU para que ya lo tengas a mano, pero recordá que para empezar a operar tendrás que hacer primero los pasos anteriores"
  }
];

export const premios = [...premiosCajaAhorro];

export const beneficios = [...beneficiosCajaAhorro];

export const motorTCCA = {
  debito: {
    accountName: "Caja de ahorro",
    cards: "Visa Débito",
    image: "tarjeta-debito.webp",
    details: [
      {
        label: "Tarjeta de débito Visa, una caja de ahorro en pesos."
      },
      {
        label:
          "Pagos sin contacto a través de App BBVA, MODO, Google Pay y Apple Pay."
      }
    ],
    benefit: "Gratis",
    maintenance: 0
  },
  vos: {
    accountName: "Tarjeta BBVA Vos",
    cards: "Visa Débito",
    image: "tarjeta-vos.webp",
    details: [
      {
        label: "Accedés a una tarjeta de crédito en 3 meses."
      },
      {
        label:
          "Transferís $80.000 o más por mes a tu cuenta en 3 meses diferentes y te ofrecemos una tarjeta de crédito."
      }
    ],
    benefit: "Gratis",
    maintenance: 0
  },
  "09": {
    accountName: "Paquete Express",
    cards: "Visa Internacional",
    image: "tarjeta-express.webp",
    details: [
      {
        label:
          "Tarjeta de crédito Visa Internacional con un límite de $visa_amount."
      },
      {
        label:
          "Tus compras suman Millas BBVA para canjear por viajes, experiencias y mucho más."
      },
      {
        label: `Además, <strong>si traés tu sueldo</strong>, vas a recibir <strong>$60.000 de regalo y un 50% de reintegro</strong> en servicios de hogar.`
      }
    ],
    benefit: "Gratis por 6 meses",
    maintenance: 34000
  },
  "01": {
    accountName: "Paquete Gold",
    cards: "Visa y Mastercard Gold",
    image: "tarjeta-gold.webp",
    details: [
      {
        label:
          "Tarjeta de crédito Visa Gold con un límite de $visa_amount y tarjeta de crédito Mastercard Gold con un límite de $mastercard_amount."
      },
      {
        label: "30% de descuento en la contratación de seguros BBVA."
      },
      {
        label:
          "Tus compras suman Millas BBVA para canjear por viajes, experiencias y mucho más."
      },
      {
        label: `Además, <strong>si traés tu sueldo</strong>, vas a recibir <strong>$120.000 de regalo y un 50% de reintegro</strong> en servicios de hogar.`
      }
    ],
    benefit: "Gratis por 6 meses",
    maintenance: 55000,
    consumo: 1000000
  },
  "08": {
    accountName: "Paquete Platinum",
    cards: "Visa y Mastercard Platinum",
    image: "tarjeta-premium.webp",
    details: [
      {
        label:
          "Tarjeta de crédito Visa Platinum con un límite de $visa_amount y tarjeta de crédito Mastercard Platinum con un límite de $mastercard_amount."
      },
      {
        label: "30% de descuento en la contratción de seguros BBVA."
      },
      {
        label:
          "Sumás un 5% extra de Millas BBVA con todas tus compras, la canjeás por vuelos, experiencias y más."
      },
      {
        label: `Además, <strong>si traés tu sueldo</strong>, vas a recibir <strong>$240.000 de regalo y un 50% de reintegro</strong> en servicios de hogar.`
      }
    ],
    benefit: "Gratis por 6 meses",
    maintenance: 81000,
    consumo: 1500000
  },
  "04": {
    accountName: "Paquete Black",
    cards: "Visa Signature y Mastercard Black",
    image: "tarjeta-premium-world.webp",
    details: [
      {
        label:
          "Tarjeta de crédito Visa Signature con un límite de $visa_amount y tarjeta de crédito Mastercard Black con un límite de $mastercard_amount."
      },
      {
        label: "30% de descuento en la contratación de seguros BBVA."
      },
      {
        label:
          "Sumás un 15% adicional de Millas BBVA con todas tus compras, las canjeás por vuelos, experiencias y más."
      },
      {
        label: `Además, <strong>si traés tu sueldo</strong>, vas a recibir <strong>$360.000 de regalo y un 50% de reintegro</strong> en servicios de hogar.`
      }
    ],
    extraDetails: { label: "Retiro de efectivo en cajeros automáticos." },
    benefit: "Gratis por 6 meses",
    maintenance: 91000,
    consumo: 2500000
  },
  cambioPerfil: {
    accountName: "Tarjeta Visa BBVA Vos",
    cards: "Visa Débito",
    image: "tarjeta-vos.webp",
    details: [
      {
        label: "Tarjeta de débito Visa BBVA Vos y caja de ahorro en pesos."
      },
      {
        label:
          "Pagos sin contacto a través de App BBVA, MODO, Google Pay y Apple Pay."
      }
    ],
    benefit: "Gratis",
    maintenance: 0,
    process: {
      title: "¿Cómo obtengo mi tarjeta de crédito BBVA?",
      steps: [
        {
          image: {
            src: "card-vos.webp",
            alt: "Tarjeta BBVA vos"
          },
          text: "Cambiá tu caja de ahorro por una Tarjeta BBVA Vos."
        },
        {
          image: {
            src: "transfer-vos.webp",
            alt: "Transfiere tarjeta vos"
          },
          text: "Transferí $80.000 o más por mes a tu cuenta."
        },
        {
          image: {
            src: "multi-card-vos.webp",
            alt: "Repetir tarjeta vos"
          },
          text: "Repetilo en 3 meses diferentes."
        }
      ],
      text: "¡Y listo! ¡Accedés a tu tarjeta de crédito!",
      subtext: "Vas a poder pagar en cuotas y viajar con Millas BBVA."
    }
  }
};
